import React from 'react';
export function Closing() {
  return <footer className="bg-gray-100 py-8 px-4 text-center border-t border-gray-200" data-id="element-65">
      <div className="max-w-3xl mx-auto flex flex-wrap justify-center gap-4 sm:gap-8 text-gray-600 font-bold text-sm sm:text-base" data-id="element-66">
        <span className="flex items-center gap-2" data-id="element-67">🔒 Compra segura</span>
        <span className="flex items-center gap-2" data-id="element-68">📩 Acceso inmediato</span>
        <span className="flex items-center gap-2" data-id="element-69">
          💛 Diseñado para familias reales
        </span>
      </div>
    </footer>;
}